<template>
  <div class="backdrop">
    <div class="common searchbox-wrapper">
      <img class="return" src="../../../assets/images/return.png" @click="$router.go(-1)">
      <input type="text" placeholder="请输入物品名称/条码" v-model="keywords" @input="getGoodsList()"/>
      <img class="material-scan" src="../../../assets/images/material-scan-icon.png">
      <!-- <img class="material-add" src="../../../assets/images/material-add.png"> -->
    </div>
    <div class="tab-wrapper">
      <div class="tab-head" v-if="goods_type_clickable">
        <div :class="{active: goods_type === 0}" @click="tab(0)">全部物资</div>
        <div :class="{active: goods_type === 1}" @click="tab(1)">易耗品</div>
        <div :class="{active: goods_type === 2}" @click="tab(2)">资产</div>
      </div>
      <div class="tab-head" v-else>
        <div :class="{active: goods_type === 0}">全部物资</div>
        <div :class="{active: goods_type === 1}">易耗品</div>
        <div :class="{active: goods_type === 2}">资产</div>
      </div>
      <div class="tab-content">
        <div class="tab-classify">
          <div class="classify-title" @click="classifyClick">{{category_name}}<img src="../../../assets/images/material-crudejt-down.png"></div>
        </div>
        <div class="tab-total">共{{totalNum}}种物品</div>
        <div class="tab-goodslist" v-for="(item, index) in goods_list" :key="index" @click="goodsDetail(item.goods_id, item.goods_name)">
          <img class="goodsimg" v-if="item.image_url" :src="item.image_url">
          <img class="goodsimg" v-else src="../../../assets/images/no-picture.jpg">
          <div class="goodsdetail">
            <div class="title">{{item.goods_name}}</div>
            <div>{{item.goods_num}}</div>
            <div>当前库存：{{item.total_goods_count}}</div>
          </div>
        </div>
      </div>
      <div v-if="see_more" @click="getGoodsList(2)" class="more">- 点击查看更多 -</div>
    </div>
    <!-- 选择资产分类 -->
    <div class="select-mask" v-if="classifyPopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择资产分类<img class="close-mask" @click="classifyClose" src="../../../assets/images/close.png"></div>
          <el-tree :data="classifyData" :props="defaultProps" :expand-on-click-node="false" node-key="id" @node-click="selectCategory"></el-tree>
        </div>
      </div>
    </div>
    <!-- 加载动画 -->
    <div class="loading" v-if="loading">
      <img src="../../../assets/images/loading.gif">
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'GoodsList',
  metaInfo: {
    title: '物品档案'
  },
  data () {
    return {
      loading: false, // 加载动画
      goods_list: [],
      totalNum: 0,
      goods_type: 0,
      keywords: '',
      page: 0, // 页码
      see_more: false, // 点击查看更多
      category_id: 0,
      category_name: '全部分类',
      classifyPopup: false, // 分类
      classifyData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      return_page: '', // 选择物品后返回页面
      return_query: {}, // 选择物品后返回页面需携带的参数
      goods_type_clickable: 1 // 分类tab是否可点击
    }
  },
  computed: {
    ...mapState(['villageId', 'memberId'])
  },
  created () {
    if (this.$route.query.goods_type) {
      this.goods_type = this.$route.query.goods_type
    }
    if (this.$route.query.goods_type_clickable !== undefined) {
      this.goods_type_clickable = this.$route.query.goods_type_clickable
    }
    if (this.$route.query.return_page) {
      this.return_page = this.$route.query.return_page
      if (this.$route.query.return_query) {
        this.return_query = this.$route.query.return_query
      }
    }
    this.getGoodsList()
    this.getCategoryTree()
  },
  methods: {
    getCategoryTree () {
      this.axios.post('/wechat/basic_info/getCategoryTree', {
        member_id: this.memberId,
        village_id: this.villageId
      }).then((res) => {
        if (res.data.status === 1) {
          this.classifyData = [{id: 0, label: '全部分类'}].concat(res.data.data)
        }
      })
    },
    getGoodsList (type = 1) {
      this.loading = true
      var goodsList = this.goods_list
      if (type === 2) {
        // 查看更多
      } else {
        // 搜索条件有变化，需重新获取列表 和 统计数据
        this.goods_list = []
        this.page = 0
        this.totalNum = 0
        goodsList = []
      }
      this.axios.post('/wechat/goods/goodsList', {
        member_id: this.memberId,
        village_id: this.villageId,
        goods_type: this.goods_type,
        keywords: this.keywords,
        category_id: this.category_id,
        page: this.page + 1
      }).then((res) => {
        if (res.data.status === 1) {
          this.goods_list = goodsList.concat(res.data.data.goods_list)
          this.totalNum = res.data.data.total
          this.page = res.data.data.page
          if (this.goods_list.length >= res.data.data.total) {
            this.see_more = false
          } else {
            this.see_more = true
          }
          this.loading = false
        } else {
          this.loading = false
          this.$toast({
            message: res.data.info,
            duration: 5000
          })
        }
      }).catch(() => {
        this.loading = false
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },
    // 切换
    tab (e) {
      this.goods_type = e
      this.getGoodsList()
    },
    goodsDetail (goodsId, goodsName) {
      if (this.return_page) { // 选择物品而来
        var returnQuery = JSON.parse(this.return_query)
        returnQuery.goods_id = goodsId
        returnQuery.goods_name = goodsName
        this.$router.push({name: this.return_page, query: returnQuery})
      } else {
        this.$router.push({name: 'GoodsDetail', query: {goods_id: goodsId}})
      }
    },
    // 点击分类
    classifyClick () {
      this.classifyPopup = true
    },
    // 关闭分类弹出
    classifyClose () {
      this.classifyPopup = false
    },
    // 点击空白地方关闭
    clickBlank () {
      this.classifyPopup = false
    },
    selectCategory (data) {
      this.category_id = data.id
      this.category_name = data.label
      this.clickBlank()
      this.getGoodsList()
    }
  }
}
</script>
<style scoped>
.common {
  padding: 15px 10px;
}
.return {
  width: 18px;
  height: 18px;
  vertical-align: top;
  padding: 5px 10px 0 0;
}
.material-add {
  width: 25px;
  height: 25px;
  padding-left: 10px;
}
.material-scan {
  position: absolute;
  top: 20px;
  right: 18px;
  width: 18px;
  height: 18px;
}
.searchbox-wrapper {
  display: flex;
  position: relative;
  margin-bottom: 0;
}
.searchbox-wrapper input {
  flex: 1;
  height: 27px;
  background-color: #f8f8f8;
  border-radius: 14px;
  border: none;
  padding: 0 28px 0 30px;
  background-image: url(../../../assets/images/repairman-search.png);
  background-size: 14px 14px;
  background-repeat: no-repeat;
  background-position: 9px center;
  outline: none;
}
.tab-wrapper {
  font-size: 15px;
}
.tab-wrapper .tab-head {
  display: flex;
  background-color: #ffffff;
}
.tab-wrapper .tab-head div {
  flex: 1;
  text-align: center;
  padding: 12px 0;
  color: #2f2f2f;
}
.tab-wrapper .tab-head div img {
  width: 18px;
  height: 18px;
  vertical-align: top;
  padding: 1px 6px 0 0;
}
.tab-wrapper .tab-head .active {
  color: #d93d55;
  position: relative;
}
.tab-wrapper .tab-head .active::after {
  content: '';
  position: absolute;
  left: 50%;
  margin-left: -27%;
  bottom: 0;
  width: 55%;
  height: 2px;
  background-color: #d93d55;
}
.tab-wrapper .tab-total {
  padding: 10px 15px;
  font-size: 14px;
  color: #8f8f8f;
}
.tab-wrapper .tab-goodslist {
  display: flex;
  background-color: #ffffff;
  padding: 12px;
}
.more {
  font-size: 14px;
  text-align: center;
  background-color: #ffffff;
  padding: 10px 0;
}
.tab-wrapper .tab-goodslist .goodsimg {
  width: 75px;
  height: 75px;
}
.tab-wrapper .tab-goodslist .goodsdetail {
  flex: 1;
  padding: 0 12px;
}
.tab-wrapper .tab-goodslist .goodsdetail div {
  color: #989898;
  font-size: 13px;
}
.tab-wrapper .tab-goodslist .goodsdetail .title {
  font-size: 15px;
  color: #43464f;
  font-weight: 700;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
}
.tab-wrapper .tab-classify {
  padding: 10px 15px;
  color: #8f8f8f;
  font-size: 14px;
  background-color: #ffffff;
}
.tab-wrapper .tab-classify .classify-title img {
  width: 10px;
  height: 10px;
  padding-left: 8px;
}
.select-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.select-mask .select-mask-blank {
  width: 100%;
  height: 100%;
}
.select-mask .select-mask-inner {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #ffffff;
  font-size: 15px;
  height: 300px;
}
.select-mask .select-mask-inner .select-mask-content {
  padding: 0 15px;
}
.select-mask .select-mask-inner .head-mask {
  text-align: center;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #f6f6f6;
  position: relative;
}
.select-mask .select-mask-inner .head-mask .close-mask {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 12px;
  right: 10px;
}
.select-mask .select-mask-inner .select-mask-content .level {
  border-bottom: 1px solid #f6f6f6;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  position: relative;
}
.select-mask .select-mask-inner .select-mask-content label {
  display: block;
  border-bottom: 1px solid #f6f6f6;
  padding: 5px 15px;
}
>>>
.mint-switch-core {
  width: 42px;
  height: 22px;
}
>>>
.mint-switch-core::before {
  width: 40px;
  height: 20px;
}
>>>
.mint-switch-core::after {
  width: 20px;
  height: 20px;
}
>>>
.el-tree-node__expand-icon {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/Goods/GoodsList.vue